import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AppIcon } from '../app-icon/app-icon';

type NativeButtonType = 'button' | 'submit' | 'reset';

@Component({
  selector: 'app-button-icon',
  imports: [AppIcon],
  templateUrl: './app-button-icon.html',
  styleUrl: './app-button-icon.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppButtonIcon {
  readonly nativeType = input<NativeButtonType>('button');
  readonly ariaLabel = input<string | undefined>(undefined);
  readonly icon = input.required<string>();
  readonly iconColor = input<string | undefined>(undefined);
  readonly iconHoverColor = input<string | undefined>(undefined);
  readonly width = input(15);
  readonly height = input(15);
  readonly disabled = input(false);
  readonly stopPropagation = input(false);
  readonly pressed = output<void>();

  protected emitPressed(event: MouseEvent): void {
    if (this.stopPropagation()) {
      event.stopPropagation();
    }

    this.pressed.emit();
  }
}
